import React from 'react';
import CusCheckbox from './CusCheckbox';
import { arraysEqual } from '../../utils';

export default function AllCheckbox({
  chosenList,
  label,
  allListId,
  setChosenList,
  checkBoxSx,
  fontWeight
}) {
  return (
    <CusCheckbox
      label={label}
      fontWeight={fontWeight}
      checked={allListId.length && arraysEqual(chosenList, allListId)}
      checkBoxSx={checkBoxSx}
      onChange={() => {
        setChosenList((prev) => (prev.length == allListId.length ? [] : allListId));
      }}
    />
  );
}
